import { Paper } from "@mui/material";

export default function GlassCard({ children, sx }) {
  return (
    <Paper
      elevation={0}
      sx={(theme) => {
        const isDark = theme.palette.mode === "dark";
        return {
          p: { xs: 1.4, sm: 2.2 },
          borderRadius: { xs: 3, sm: 4 },
          border: isDark
            ? "1px solid rgba(255,255,255,0.08)"
            : "1px solid rgba(0,0,0,0.08)",
          background: isDark ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.78)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          boxShadow: {
            xs: isDark ? "0 10px 26px rgba(0,0,0,0.25)" : "0 10px 26px rgba(0,0,0,0.05)",
            sm: isDark ? "0 14px 40px rgba(0,0,0,0.28)" : "0 14px 40px rgba(0,0,0,0.06)",
          },
          maxWidth: "100%",
          overflow: "hidden",
          ...sx,
        };
      }}
    >
      {children}
    </Paper>
  );
}
